'use client'

import clsx from 'clsx'
import { PDFViewer } from '@/components/PDFViewer/PDFViewer'
import { useIsEmbedded } from '@/utils/useIsEmbedded'
import { NeArrow } from 'ui/src/icons/NeArrow'
import { arrow, documentType, ellipsis, fileLink } from './InsuranceDocumentLink.css'

type Props = {
  url: string
  displayName: string
  onClick?: () => void
  className?: string
}

export function InsuranceDocumentLink({ className, url, displayName, onClick }: Props) {
  const extension = getExtensionFromUrl(url)
  const isEmbedded = useIsEmbedded()

  if (isEmbedded) {
    return (
      <PDFViewer url={url}>
        <button className={clsx(fileLink, className)}>
          <span className={ellipsis}>
            {displayName} <sup className={documentType}>{extension}</sup>
          </span>

          <NeArrow className={arrow} size="1rem" />
        </button>
      </PDFViewer>
    )
  }

  return (
    <a className={clsx(fileLink, className)} href={url} target="_blank" rel="noopener nofollow" onClick={onClick}>
      <span className={ellipsis}>
        {displayName} <sup className={documentType}>{extension}</sup>
      </span>

      <NeArrow className={arrow} size="1rem" />
    </a>
  )
}

const getExtensionFromUrl = (urlString: string): string => {
  try {
    const url = new URL(urlString)
    if (url.pathname.includes('.')) {
      return url.pathname.split('.').at(-1)!
    }
    return ''
  } catch {
    console.warn(`Failed to parse url: ${urlString}`)
    return ''
  }
}
